import { z } from 'zod';

import { defineFcm } from '../shared/factory';

export const FCM_SAP_INTRO_CAMPAIGN_MELONES = defineFcm('sap_intro_campaign_melones')
	.asJson(
		z
			.object({
				enabled: z.boolean(),
				// An empty string keeps the normal intro copy for that field.
				description: z.string(),
				button: z.string(),
				// A static asset path, so the front end can resolve it to each environment's static host. The image has the
				// heading drawn in, so it replaces the normal image and heading, and its alt text is the page heading. Empty
				// keeps the normal image and heading.
				imageUrl: z.union([
					z.literal(''),
					z.string().regex(/^\/[^/]/, 'imageUrl must be a static asset path like /sap3/image.webp, not a full URL'),
				]),
				imageAlt: z.string(),
			})
			// The image is the page heading, so it needs alt text or screen readers get an empty heading.
			.refine(({ imageUrl, imageAlt }) => !imageUrl || imageAlt.trim(), {
				message: 'imageAlt is required when imageUrl is set',
				path: ['imageAlt'],
			}),
	)
	.withDefault({ enabled: false, description: '', button: '', imageUrl: '', imageAlt: '' })
	.toConfig({
		owner: 'squad-starfish',
		scope: 'corgi-front-end',
		// Locale-scoped so the campaign and its copy can run in one market (`es-ES`) without touching the others.
		supportedGroups: { locales: true },
		context: 'SAP intro campaign',
		description:
			'Turns on the temporary "melones" campaign version of the Start a Petition (SAP) intro step and holds its copy. When enabled, the campaign shows only to visitors whose link has `sap_campaign=melones`; everyone else sees the normal intro. Leave a copy field empty to keep the normal intro text for it. `imageUrl` is the static.change.org path (e.g. `/sap3/image.webp`) of an image with the heading drawn into it (one image for light and dark mode, ~1200px wide): it replaces both the normal image and heading. `imageAlt` must spell out the text in the image, because it becomes the page heading for screen readers. Leave `imageUrl` empty to keep the normal image and heading. CHANGE-102558',
		template: {
			enabled: false,
			description: '',
			button: '',
			imageUrl: '',
			imageAlt: '',
		},
	});
